import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

const LoadingComponent = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: theme.palette.background.default,
        display: "flex",
        width: "100vw",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <span className="loader"></span>
    </Box>
  );
};

export default LoadingComponent;
